module.exports = "/images/aerial-14.jpg";